/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 24.01.13, 13:51
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { HTMLLinkFormatVO } from "./HTMLLinkFormatVO";

export class HTMLLinkFormatsVO {
    public linkHoverFormat: HTMLLinkFormatVO;
    public linkActiveFormat: HTMLLinkFormatVO;
    public linkNormalFormat: HTMLLinkFormatVO;
    constructor(hover: HTMLLinkFormatVO, active: HTMLLinkFormatVO, normal: HTMLLinkFormatVO) {
        this.linkHoverFormat = hover;
        this.linkActiveFormat = active;
        this.linkNormalFormat = normal;
    }
}
